import { render, staticRenderFns } from "./ReceiveNotificationModal.vue?vue&type=template&id=0cffb84e&scoped=true&"
import script from "./ReceiveNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ReceiveNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveNotificationModal.vue?vue&type=style&index=0&id=0cffb84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffb84e",
  null
  
)

export default component.exports